var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-wrapper"},[_c('svg',{staticClass:"icon",attrs:{"width":_vm.width,"height":_vm.height}},[_c('use',_vm._b({},'use',{ 'xlink:href': '/feather-sprite.svg#' + _vm.name },false))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }